// Floral Dodoens Preorder Site (React) — keep webshop open, extend progress to 100, show 60-crate milestone + bilingual price tiers

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Backend base URL (Render). Set on Vercel as NEXT_PUBLIC_API_BASE.
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.NEXT_PUBLIC_API_BASE ||
  "https://floral-backend-gh43.onrender.com";

// Progress config: brew confirmed at 60, continue toward 100
const MILESTONE = 60;
const GOAL = 100;

function FloralPreorder() {
  const [quantity, setQuantity] = useState(1);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [delivery, setDelivery] = useState("pickup");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  // Live counter
  const [sold, setSold] = useState(0);

  // Dynamic price tiers
  let basePrice = 40;
  if (sold >= 60 && sold < 100) basePrice = 45;
  if (sold >= 100) basePrice = 50;

  const deliveryFee = quantity >= 4 ? 0 : 5;
  const total = quantity * basePrice + (delivery === "delivery" ? deliveryFee : 0);

  // Fetch total sold on load + light polling
  useEffect(() => {
    let isMounted = true;

    const fetchTotal = async () => {
      try {
        const r = await fetch(`${API_BASE}/total-sold`);
        if (!r.ok) return;
        const { total } = await r.json();
        if (isMounted && Number.isFinite(total)) setSold(total);
      } catch (_) {}
    };

    fetchTotal(); // initial
    const id = setInterval(fetchTotal, 15000); // every 15s

    return () => {
      isMounted = false;
      clearInterval(id);
    };
  }, []);

  const progressPercentage = Math.min(100, (sold / GOAL) * 100);
  const reachedMilestone = sold >= MILESTONE;

  return (
    <div style={{ minHeight: "100vh", padding: "2rem", maxWidth: "600px", margin: "0 auto", fontFamily: "sans-serif" }}>
      <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "0.5rem" }}>Preorder Floral Dodoens 🍻</h1>
      <p style={{ marginBottom: "1.5rem" }}>
        <strong>🇳🇱</strong> De botteling van het bier kan enkel door gaan vanaf het voorverkoop van <strong>60</strong> bakken Floral Dodoens. Uw steun helpt voor het aankopen van flessen en etiketten.<br />
        In voorverkoop kost een doos van 24 flessen (33cl) <strong>40 €</strong> tot 60 bakken, <strong>45 €</strong> tussen 60 en 100 bakken, en daarna <strong>50 €</strong> per doos.<br />
        Levering kost <strong>€5</strong> tenzij u <strong>4 of meer kratten</strong> bestelt (gratis levering).<br /><br />
        <strong>🇫🇷</strong> L'embouteillage ne sera lancé qu'à partir de <strong>60</strong> caisses. Votre soutien permet de financer les bouteilles et les étiquettes.<br />
        En prévente la caisse de 24 bouteilles (33 cl) revient à <strong>40 €</strong> jusqu’à 60 caisses, <strong>45 €</strong> entre 60 et 100 caisses, puis <strong>50 €</strong> par caisse au-delà.<br />
        Livraison à <strong>5€</strong>, offerte dès <strong>4 caisses</strong>.
      </p>

      {/* Celebration GIF once milestone reached (60) */}
      {reachedMilestone && (
        <div style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          <img
            src="/celebration.gif"
            alt="Milestone reached!"
            style={{ width: "100%", maxWidth: "320px", borderRadius: "8px" }}
          />
          <p style={{ marginTop: "0.5rem", fontWeight: 600 }}>
            🎉 60 kratten gehaald! / Objectif 60 caisses atteint !
          </p>
        </div>
      )}

      <div style={{ marginBottom: "1rem" }}>
        <label>Naam / Nom</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} style={inputStyle} />
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>Adres / Adresse</label>
        <textarea value={address} onChange={(e) => setAddress(e.target.value)} rows="3" style={inputStyle}></textarea>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>E-mail</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>Telefoon / Téléphone</label>
        <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} style={inputStyle} />
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label>Levering / Livraison</label>
        <select value={delivery} onChange={(e) => setDelivery(e.target.value)} style={inputStyle}>
          <option value="pickup">Afhalen in Tremelo / Retrait à Tremelo</option>
          <option value="delivery">Levering binnen 30 km / Livraison dans un rayon de 30 km</option>
        </select>
      </div>

      <div style={{ marginBottom: "1.5rem" }}>
        <label>Aantal kratten / Nombre de caisses</label>
        <input
          type="number"
          min="1"
          value={quantity}
          onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
          style={{ ...inputStyle, width: "80px" }}
        />
      </div>

      <button
        onClick={handlePreorder}
        style={{ padding: "0.75rem 1.5rem", backgroundColor: "#1d4ed8", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", marginBottom: "1.5rem" }}
      >
        Bancontact: €{total.toFixed(2)}
      </button>

      {/* Progress block with 60 marker and 100 goal */}
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 600, marginBottom: 6 }}>
          <span>{sold} / {GOAL}{sold > GOAL ? "+" : ""} crates</span>
          <span>{Math.round(progressPercentage)}%</span>
        </div>

        <div style={barOuter}>
          <div style={{ ...barFill, width: `${progressPercentage}%` }}></div>

          {/* 60-crate milestone marker */}
          <div
            title={`Prebuy milestone (${MILESTONE} crates)`}
            style={{
              ...markerLine,
              left: `${(MILESTONE / GOAL) * 100}%`,
            }}
          >
            <span style={markerLabel}>{MILESTONE}</span>
          </div>
        </div>

        <p style={{ marginTop: 8, opacity: 0.9 }}>
          ✅ Prebuy milestone reached at 60 — brewing confirmed. Webshop remains open; next stop: 100 crates.
        </p>
      </div>

      <p style={{ fontSize: "0.85rem", marginTop: "1.5rem", color: "#555" }}>
        📜 We respecteren uw privacy. Uw gegevens worden niet verkocht of gedeeld. / Vos informations personnelles ne seront jamais revendues.
      </p>
    </div>
  );

  async function handlePreorder() {
    if (!name || !address || (!email && !phone)) {
      alert(
        "Gelieve uw naam, adres en minstens e-mail of telefoonnummer in te vullen. / Veuillez entrer votre nom, adresse et au moins un moyen de contact."
      );
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/create-payment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, address, quantity, delivery, email, phone }),
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body?.error || "Server error");
      }

      const { paymentUrl, paymentId } = await response.json();

      if (paymentId) {
        sessionStorage.setItem("paymentId", paymentId);
      }

      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        alert("Betaling mislukt. / Échec du paiement.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert("Er is een fout opgetreden. / Une erreur s'est produite.");
    }
  }
}

function ThankYouPage() {
  const [sold, setSold] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const fetchTotal = async () => {
      try {
        const r = await fetch(`${API_BASE}/total-sold`);
        if (!r.ok) return;
        const { total } = await r.json();
        if (isMounted && Number.isFinite(total)) setSold(total);
      } catch (_) {}
    };

    fetchTotal();
    const id = setInterval(fetchTotal, 15000);

    return () => {
      isMounted = false;
      clearInterval(id);
    };
  }, []);

  useEffect(() => {
    const paymentId = sessionStorage.getItem("paymentId");
    if (!paymentId) return;

    let attempts = 0;
    const max = 6;
    const wait = 1000;

    const send = async () => {
      attempts++;
      try {
        const r = await fetch(`${API_BASE}/send-confirmations`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ paymentId }),
        });
        if (!r.ok) {
          const body = await r.json().catch(() => ({}));
          throw new Error(body?.error || `HTTP ${r.status}`);
        }
      } catch (e) {
        if (attempts < max) setTimeout(send, wait);
      }
    };

    send();
  }, []);

  const progressPercentage = Math.min(100, (sold / GOAL) * 100);
  const reachedMilestone = sold >= MILESTONE;

  return (
    <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
      <h1>🎉 Merci / Dank u!</h1>
      <p>
        <strong>FR / NL</strong> Votre commande est bien enregistrée. Nous vous contacterons bientôt pour la livraison ou le retrait.<br />
        Uw bestelling is goed ontvangen. We nemen snel contact met u op voor levering of afhaling.
      </p>

      <div style={{ margin: "2rem auto", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 600, marginBottom: 6 }}>
          <span>{sold} / {GOAL}{sold > GOAL ? "+" : ""} crates</span>
          <span>{Math.round(progressPercentage)}%</span>
        </div>

        <div style={{ ...barOuter, margin: 0 }}>
          <div style={{ ...barFill, width: `${progressPercentage}%` }}></div>
          <div
            title={`Prebuy milestone (${MILESTONE} crates)`}
            style={{ ...markerLine, left: `${(MILESTONE / GOAL) * 100}%` }}
          >
            <span style={markerLabel}>{MILESTONE}</span>
          </div>
        </div>
        {reachedMilestone && (
          <p style={{ marginTop: "0.5rem", fontWeight: 600 }}>
            🎉 60 crates milestone reached!
          </p>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "2rem" }}>
        <img
          src="/beer-bottle.gif"
          alt="Floral Dodoens bottle"
          style={{ width: "100%", maxWidth: "300px", borderRadius: "8px" }}
        />
        <p style={{ marginTop: "1rem", fontSize: "0.9rem", color: "#666", textAlign: "center" }}>
          🍻 Santé! / Schol!
        </p>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FloralPreorder />} />
        <Route path="/thankyou" element={<ThankYouPage />} />
      </Routes>
    </Router>
  );
}

const inputStyle = {
  width: "100%",
  padding: "0.5rem",
  border: "1px solid #ccc",
  borderRadius: "4px",
  marginTop: "0.25rem",
};

// Inline styles for the progress UI
const barOuter = {
  position: "relative",
  backgroundColor: "#e5e7eb",
  height: "1rem",
  borderRadius: 999,
  overflow: "hidden",
};
const barFill = {
  height: "100%",
  background: "linear-gradient(90deg, #16a34a, #a3e635)",
};
const markerLine = {
  position: "absolute",
  top: -6,
  width: 2,
  height: 28,
  background: "#ef4444",
  transform: "translateX(-50%)",
};
const markerLabel = {
  position: "absolute",
  top: -20,
  left: "50%",
  transform: "translateX(-50%)",
  fontSize: 12,
  color: "#ef4444",
};
